import { useGetDMaxCommon, useGetRoom, type RoomBaseInfoResponse, type RoomDMaxInfoResponse } from "@/shared/server";
import { Center, Spinner, Text } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { RoomDetail, RoomFeed } from "../common";
import { OtherRoomPreView } from "../common/components/otherRoomPreview";
import { TopSection } from "../common/components/topSection";

export const Rooms = () => {
    const { roomIdx } = useParams<string>();
    const { data: roomData } = useGetDMaxCommon<RoomDMaxInfoResponse>({ section: "room" });
    const option = { enabled: !!roomIdx };

    const { data } = useGetRoom<RoomBaseInfoResponse>({ roomIdx: roomIdx ?? "" }, option);
    const targetRoom = roomData?.rooms.find((t) => t.room_idx === roomIdx);
    const sector = {
        main: {
            firstLine: targetRoom?.room_name || "",
            secondLine: targetRoom?.room_intro || "",
        },
        sub: {
            firstLine: "",
            secondLine: "",
        },
    };

    const otherRoomList = roomData?.rooms.filter((t) => t.room_idx !== roomIdx);
    return data && targetRoom && otherRoomList ? (
        <>
            <TopSection imgList={targetRoom.imgList} sector={sector} />
            <RoomDetail room={targetRoom} />
            <RoomFeed room={targetRoom} />
            {/* <BackBanner imgUrl={data.imgList[0].imgUrl} /> */}
            <OtherRoomPreView roomList={otherRoomList} />
        </>
    ) : (
        <Center w="100" h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
